import _ from 'lodash';
import { createNamespacedHelpers } from 'vuex';
import * as types from '../types';
import { prepend } from '../utils';

const serverNotification = _.get(window, 'pageParams.notification.message', '');

export const defaultState = {
  show: false,
  message: '',
  icon: '',
  iconColor: '',
  color: '',
};

export const namespace = 'notifications';
export const helpers = createNamespacedHelpers(namespace);
export const prependNamespace = prepend(namespace);

export const notificationTimeout = process.env.NODE_ENV === 'test' ? 100 : 7000;

export const mutations = {
  [types.SET_FIELDS]: _.merge,
};

export const actions = {
  [types.SHOW_SNACKBAR]({ commit, dispatch }, params) {
    commit(types.SET_FIELDS, { show: true, ...params });
    return dispatch(types.RESET_SNACKBAR);
  },
  [types.RESET_SNACKBAR]({ commit }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit(types.SET_FIELDS, defaultState);
        resolve();
      }, notificationTimeout);
    });
  },
};

export default {
  namespaced: true,
  state: {
    ...defaultState,
    show: !_.isEmpty(serverNotification),
    message: serverNotification,
  },
  mutations,
  actions,
};
